import { GIFT_PASS_BUNDLE_NAME_MAX_LENGTH } from '@bonsai/shared';

import { fieldBoxStyle } from '../../../shared/date-time-range/picker-styles';
import { EditorFieldError } from '../../shared/editor-page/EditorFieldError';
import { EditorFormSection } from '../../shared/editor-page/EditorFormSection';

export interface BundleNameSectionProps {
  value: string;
  error?: string;
  onChange: (name: string) => void;
}

export function BundleNameSection({ value, error, onChange }: BundleNameSectionProps) {
  return (
    <EditorFormSection
      title="Bundle name"
      titleId="bundle-name-title"
      hintId="bundle-name-hint"
      hint="Shown to customers as the pack name, e.g. “4-Pack”."
    >
      <input
        aria-labelledby="bundle-name-title"
        aria-describedby={error ? 'bundle-name-error' : 'bundle-name-hint'}
        aria-invalid={Boolean(error)}
        value={value}
        maxLength={GIFT_PASS_BUNDLE_NAME_MAX_LENGTH}
        placeholder="e.g. 4-Pack"
        onChange={(e) => onChange(e.target.value)}
        style={{ ...fieldBoxStyle(false, Boolean(error)), width: '100%', fontSize: 14 }}
      />
      {error && <EditorFieldError id="bundle-name-error">{error}</EditorFieldError>}
    </EditorFormSection>
  );
}
